import ScrollingTabs from './ScrollingTabs';

export default ScrollingTabs;
